import React from 'react';
import {TechnicalData} from '../types/ManagementOverviewReport.types';
import {
    formatManagementDecimal,
    formatTechnicalField,
} from '../utils/managementOverviewFormatters';
import ReportSectionTitle from './ReportSectionTitle';

interface TechnicalDataPanelProps {
    technicalData: TechnicalData;
    stationName: string;
}

const TechnicalDataPanel: React.FC<TechnicalDataPanelProps> = ({ technicalData, stationName }) => {
    const coordinates = `${formatTechnicalField(technicalData.latitude)}/${formatTechnicalField(technicalData.longitude)}`;
    const cityState = `${formatTechnicalField(technicalData.city)}/${formatTechnicalField(technicalData.state)}`;
    const capacity = `${formatManagementDecimal(technicalData.maxPowerMw)} Mw / ${formatManagementDecimal(technicalData.nominalCapacityMw)} Mw`;

    return (
        <section className="management-overview-technical-data avoid-break">
            <ReportSectionTitle>Dados Técnicos</ReportSectionTitle>
            <div className="management-overview-technical-data__layout">
                <div className="management-overview-technical-data__fields">
                    <div className="management-overview-technical-data__box">
                        <p>
                            <span className="management-overview-technical-data__label">Localizado em</span>
                            <span>{formatTechnicalField(technicalData.address)}</span>
                        </p>
                        <p>
                            <span className="management-overview-technical-data__label">Coordenadas:</span>
                            <span>{coordinates}</span>
                        </p>
                        <p>
                            <span className="management-overview-technical-data__label">Cidade/Estado:</span>
                            <span>{cityState}</span>
                        </p>
                        <p>
                            <span className="management-overview-technical-data__label">CEP:</span>
                            <span>{formatTechnicalField(technicalData.zipCode)}</span>
                        </p>
                    </div>
                    <div className="management-overview-technical-data__box">
                        <p>
                            <span className="management-overview-technical-data__label">Capacidade Max/Nominal:</span>
                            <span>{capacity}</span>
                        </p>
                        <p>
                            <span className="management-overview-technical-data__label">Quantidade de Skids:</span>
                            <span>{technicalData.skidCount}</span>
                        </p>
                        <p>
                            <span className="management-overview-technical-data__label">Quantidade de Inversores:</span>
                            <span>{formatTechnicalField(technicalData.invertersText)}</span>
                        </p>
                    </div>
                </div>
                <div className="management-overview-technical-data__image-panel">
                    <p className="management-overview-technical-data__station-name">{stationName}</p>
                    <img
                        src={`${process.env.PUBLIC_URL}/solar-panel-xl.jpeg`}
                        alt=""
                        className="management-overview-technical-data__image"
                        onError={(event) => {
                            event.currentTarget.style.display = 'none';
                            const fallback = event.currentTarget.nextElementSibling;
                            if (fallback instanceof HTMLElement) {
                                fallback.hidden = false;
                            }
                        }}
                    />
                    <div className="management-overview-technical-data__image-fallback" hidden>
                        Imagem da usina indisponível
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TechnicalDataPanel;
